import * as React from "react";
import MenuList from "@mui/material/MenuList";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import { useListContext } from "react-admin";
import { Box } from "@mui/material";
import CustomSelect from "../unit/forms/CustomSelect";
import { hmLightTheme } from "../themes/hmTheme";
import formatTitleText from "../unit/formatTitleText";

const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  return (
    <Box
      sx={{
        width: "100%",
        textTransform: "uppercase",
      }}
    >
      {type}
      {/* <Chip
        label={appCounts}
        size="small"
        sx={{
          ml: 1,
          float: "right",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
        }}
      /> */}
    </Box>
  );
};

const AchPaymentMenus = [
  {
    disbursement: [
      { "Unable to Initiate (Last 30 Days)": 0 },
      { "Failed (Last 30 Days)": 0 },
      { "Processed (Last 30 Days)": 0 },
      { Processing: 0 },
      { Today: 0 },
      { "Scheduled (Next 30 Days)": 0 },
    ],
  },
  {
    repayment: [
      { "Unable to Initiate (Last 30 Days)": 0 },
      { "Failed (Last 30 Days)": 0 },
      { "Processed (Last 30 Days)": 0 },
      { Processing: 0 },
      { Today: 0 },
      { "Scheduled (Next 30 Days)": 0 },
    ],
  },
  {
    refill: [
      { "Unable to Initiate (Last 30 Days)": 0 },
      { "Failed (Last 30 Days)": 0 },
      { "Processed (Last 30 Days)": 0 },
      { Processing: 0 },
      { Today: 0 },
      { "Scheduled (Next 30 Days)": 0 },
    ],
  },
  {
    deposit: [
      { "Unable to Initiate (Last 30 Days)": 0 },
      { "Failed (Last 30 Days)": 0 },
      { "Processed (Last 30 Days)": 0 },
      { Processing: 0 },
      { Today: 0 },
      { "Scheduled (Next 30 Days)": 0 },
    ],
  },
  {
    refund: [
      { "Unable to Initiate (Last 30 Days)": 0 },
      { "Failed (Last 30 Days)": 0 },
      { "Processed (Last 30 Days)": 0 },
      { Processing: 0 },
      { Today: 0 },
      { "Scheduled (Next 30 Days)": 0 },
    ],
  },
];

const AchPaymentsAside = ({ ...props }) => {
  const { filterValues } = useListContext();
  const [selectMenu, setSelectMenu] = React.useState("disbursement");
  const status = filterValues.status;
  const totalData = props.totalData;
  let headerTitle = `Data as of 00:00 ${
    new Date().toISOString().split("T")[0]
  } EST`;
  let headerSubTitle = "";
  if (status?.includes("Today")) {
    headerSubTitle = `( You may cancel and change any transfers scheduled for today before 3:45pm Eastern Time. )`;
  }
  return (
    <>
      <HmSubHeaderTitle
        title={headerTitle}
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      {headerSubTitle && (
        <HmSubHeaderTitle
          title={headerSubTitle}
          sx={{
            display: "block",
            position: "absolute",
            top: "75px",
            left: "350px",
            fontSize: "14px",
          }}
        />
      )}

      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 1, height: "100%" }}>
          <MenuList component="div" id="list-ach-attention-menus">
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              {/* 120-Day Failed ACH */}
              Attention Required
            </Typography>
            {/* 120-Day Failed ACH  */}
            <CustomMenuItemLink
              key={"120-day-failed-ach"}
              to={`/achpayment?filter={"status":"120-Day Failed ACH"}`}
              selected={status === "120-Day Failed ACH"}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type={"Failed (Last 120 Days)"} count={0} />
              }
              tooltipProps={{
                title: "Failed (last 120 days)",
                children: <></>,
              }}
            />
          </MenuList>

          <MenuList sx={{ mt: 0, pt: 0 }} id="list-ach-processing-menus">
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                mt: 0,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              {/* 60-Day ACH Processing */}ACH Processing Activity
            </Typography>
            <CustomSelect
              name="datelimit"
              className="datelimit"
              sx={{ width: "100%", textAlign: "left", mb: 1 }}
              optionlist={[
                { value: "disbursement", label: "Disbursement" },
                { value: "repayment", label: "Repayment" },
                { value: "deposit", label: "Deposit" },
                { value: "refund", label: "Refund" },
                { value: "refill", label: "Refill" },
              ]}
              value={selectMenu}
              fullWidth
              variant="outlined"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSelectMenu(e.target.value);
              }}
            />
            {/* <CustomMenuItemLink
              key={"Not Initiated"}
              to={`/achpayment?filter={"status":"Not Initiated"}`}
              selected={status === "Not Initiated"}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type={"Not Initiated (Last 30 Days)"} count={0} />
              }
              tooltipProps={{
                title: "Not Initiated",
                children: <></>,
              }}
            />
            <CustomMenuItemLink
              key={"Processing"}
              to={`/achpayment?filter={"status":"Processing"}`}
              selected={status === "Processing"}
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type={"Processing"} count={0} />}
              tooltipProps={{
                title: "Processing",
                children: <></>,
              }}
            />
            <CustomMenuItemLink
              key={"Failed"}
              to={`/achpayment?filter={"status":"Failed"}`}
              selected={status === "Failed"}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type={"Failed (Last 30 Days)"} count={0} />
              }
              tooltipProps={{
                title: "Failed",
                children: <></>,
              }}
            />
            <CustomMenuItemLink
              key={"Processed"}
              to={`/achpayment?filter={"status":"Processed"}`}
              selected={status === "Processed"}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type={"Processed (Last 30 Days)"} count={0} />
              }
              tooltipProps={{
                title: "Processed",
                children: <></>,
              }}
            />
            <CustomMenuItemLink
              key={"Scheduled"}
              to={`/achpayment?filter={"status":"Scheduled"}`}
              selected={status === "Scheduled"}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type={"Scheduled (Next 30 Days)"} count={0} />
              }
              tooltipProps={{
                title: "Scheduled",
                children: <></>,
              }}
            /> 
            <hr />*/}
            {AchPaymentMenus.map((menu, index) => {
              const [key, items] = Object.entries(menu)[0];
              if (key != selectMenu) {
                return <></>;
              }
              return items.map((item, subIndex) => {
                const [subKey, count] = Object.entries(item)[0];
                const type = `${
                  key.charAt(0).toUpperCase() + key.slice(1)
                } - ${subKey}`;
                return (
                  <>
                    <CustomMenuItemLink
                      sx={{
                        "& .MuiTypography-root": {
                          pl: 0,
                        },
                      }}
                      key={`${index}-${subIndex}`}
                      to={`/achpayment?filter={"status":"${type}"}`}
                      onClick={() => {
                        //if type have Disbursement，set selectMenu to disbursement
                        if (type.includes("Disbursement")) {
                          setSelectMenu("disbursement");
                        }
                        if (type.includes("Repayment")) {
                          setSelectMenu("repayment");
                        }
                        if (type.includes("Refill")) {
                          setSelectMenu("refill");
                        }
                        if (type.includes("Deposit")) {
                          setSelectMenu("deposit");
                        }
                        if (type.includes("Refund")) {
                          setSelectMenu("refund");
                        }
                      }}
                      state={{ _scrollToTop: true }}
                      primaryText={<AppMenuTitle type={subKey} count={count} />}
                      tooltipProps={{
                        title: formatTitleText(type),
                        children: <></>,
                      }}
                      selected={status === type}
                    />
                    {(subIndex == 0 || subIndex == 2 || subIndex == 4) && (
                      <hr />
                    )}
                  </>
                );
              });
            })}
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default AchPaymentsAside;
